import cn from "classnames";
import React, { useRef, } from "react";
import styles from "./textInput.module.less";

interface FormFieldProps {
    label: React.ReactNode
    required?: boolean
    error?: string
    helper?: React.ReactNode
    children: React.ReactNode
}

export const FormField: React.FC<FormFieldProps> = ({ label, required, error, helper, children }) => (
    <div className={styles.formField}>
        <div className={styles.fieldLabel}>
            <p className={styles.fieldLabelText}>{label}</p>
            {required && <span className={styles.fieldRequired}>*</span>}
        </div>
        {children}
        {error && <p className={styles.fieldError}>{error}</p>}
        {helper && !error && <p className={styles.fieldHelper}>{helper}</p>}
    </div>
)


interface TextInputProps {
    name: string
    value: string
    onChange: (value: string) => void
    placeholder?: string
    type?: string
    hasError?: boolean
    disabled?: boolean
    rightIcon?: React.ReactNode
    max?: string
}

export const TextInput: React.FC<TextInputProps> = ({ name, value, onChange, placeholder, type = 'text', hasError, disabled, rightIcon, max }) => {
    const inputRef = useRef<HTMLInputElement>(null)

    return (
        <div className={cn(styles.textInput, {[styles.hasError]: hasError, [styles.disabled]: disabled, [styles.noNativeIcons]: !!rightIcon})}>
            <input
                ref={inputRef}
                name={name}
                type={type}
                value={value}
                onChange={e => onChange(e.target.value)}
                placeholder={placeholder}
                disabled={disabled}
                readOnly={disabled}
                max={max}
            />
            {rightIcon && (
                <div className={styles.textInputRightIcon} onClick={() => inputRef.current?.showPicker?.()}>
                    {rightIcon}
                </div>
            )}
        </div>
    )
}